import LegalPage from "@/components/feature/LegalPage";

export default function TermsConditions() {
  return (
    <LegalPage
      title="Terms & Conditions"
      subtitle="Please read these terms carefully before using this website."
      crumbs={[{ label: "Home", to: "/" }, { label: "Terms & Conditions" }]}
      sections={[
        {
          heading: "Use of this website",
          paragraphs: [
            "This website is provided for general information about Ortho Spine Care and the services offered. By using this website you agree to these terms. Content may be updated without notice.",
          ],
        },
        {
          heading: "No medical advice",
          paragraphs: [
            "The content on this website does not constitute medical advice, diagnosis or treatment and is not a substitute for consultation with a qualified healthcare professional.",
          ],
        },
        {
          heading: "Appointment requests",
          paragraphs: [
            "Submitting an appointment form is a request only. An appointment is confirmed only after our team contacts you. For urgent medical concerns, please call the clinic directly or seek emergency care.",
          ],
        },
        {
          heading: "Intellectual property",
          paragraphs: [
            "All content, branding and materials on this website belong to Ortho Spine Care unless otherwise stated and may not be reproduced without permission.",
          ],
        },
      ]}
    />
  );
}